<template>
  <CBox
    display="flex"
    flexDirection="column"
  >
    <OmtRow :mb="['26px', '32px']">
      <OmtTypography
        as="h1-bold"
        color="var(--colors-light-primary-navy-blue)"
      >
        Busque por especialidade
      </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography
        as="h2-bold"
        color="#4A5E77"
      >
        {{ getEstablishmentDescription }}
      </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtInput
        v-model="inputText"
        variant="filled"
        placeholder="Busque por especialidade"
        icon-right="search"
      />
    </OmtRow>
    <template v-if="filteredSpecialities.length === 0 && loading">
      <OmtRow>
        <OmtTypography
          as="h2-semi-bold"
          color="#4A5E77"
        >
          Nenhuma especialidade encontrada
        </OmtTypography>
      </OmtRow>
    </template>
    <template v-else>
      <OmtRow
        v-for="(spec, idx) in filteredSpecialities"
        :key="'spec-' + idx"
      >
        <OmtTile
          cursor="pointer"
          :divider="idx !== filteredSpecialities.length - 1"
          @click="handleClick(spec)"
        >
          <OmtTypography
            as="h2-semi-bold"
            color="#4A5E77"
          >
            {{ capitalizeWords(spec.DescricaoEspecialidade) }}
          </OmtTypography>
        </OmtTile>
      </OmtRow>
    </template>
  </CBox>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { capitalizeWords } from "@/utils/utils";

export default {
  name: "Specialities",
  data() {
    return {
      inputText: "",
      loading: false
    };
  },
  computed: {
    ...mapState("openNetworkSearch", ["rede", "especialidadesAnonimo", "selectedEstablishmentType"]),
    ...mapGetters("openNetworkSearch", ["getEstablishmentDescription"]),
    specialities() {
      return this.especialidadesAnonimo || [];
    },
    filteredSpecialities() {
      if (!this.inputText) return this.specialities;
      return this.specialities.filter(speciality =>
        speciality.DescricaoEspecialidade.toLowerCase().includes(this.inputText.toLowerCase())
      );
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["setSpecialty", "fetchEspecialidadesAnonimo", "resetRegioesAnonimo"]),
    ...mapMutations("openNetworkSearch", ["SET_REGIOES_ANONIMO"]),
    async loadEspecialidades() {
      this.loading = true;
      try {
        await this.fetchEspecialidadesAnonimo({
          rede: this.rede,
          nomeEspecialidade: ""
        });
      } catch (error) {
        console.error("Erro ao carregar especialidades:", error);
      } finally {
        this.loading = false;
      }
    },
    handleClick(spec) {
      this.setSpecialty(spec);
      this.resetRegioesAnonimo();
      this.$router.push({ name: "network.location" });
    },
    capitalizeWords(inputString) {
      return capitalizeWords(inputString);
    }
  },
  async mounted() {
    this.$root.$emit("show-loading");
    await this.loadEspecialidades();
    this.$root.$emit("hide-loading");
  }
};
</script>
